export const COPY_OPENING_HOURS = "COPY_OPENING_HOURS";
export const LOCK_OPENING_HOURS_DAY = "LOCK_OPENING_HOURS_DAY";
export const SET_OPEN_ON_EVENT_DAY = "SET_OPEN_ON_EVENT_DAY";
